module.exports = __webpack_public_path__ + "img/8.88.e25bfbde.png";